<gl-mobile-menu
    *ngIf="isMenuOpen()"
    [mobileMenuOpen]="isMenuOpen()"
    [trapFocus]="false"
    [isContrast]="highContrast$ | async"
    [loggedInCustomer]="loggedInCustomer"
    (didToggleMobileMenu)="toggleMobileMenu()"
    (didCloseMobileMenu)="closeMobileMenu()"
    (didLogOut)="logout()"
    (didLanguageChange)="handleLanguageChange($event)"
    (themeToggle)="toggleContrast()"
    tabindex="0"
    ridangoAutofocus>
</gl-mobile-menu>

<ion-toolbar [attr.data-theme]="this.env.THEME_NAME" [attr.data-high-contrast]="highContrast$ | async">
    <ion-list
        class="vl-app-light:bg-[#085667] pn-app-light:bg-primary sr-app-light:bg-[#2F2F2F] h-15x my-1 flex bg-secondary py-px dark:border dark:border-solid dark:border-contrast-yellow dark:bg-contrast-black"
        [attr.aria-label]="'APP_MENU' | translate"
        lines="none">
        <ng-container *ngFor="let menuItem of menuItems; trackBy: trackByMenuItem">
            <ion-item
                class="block h-full min-w-fit"
                *ngIf="
                    menuItem === MenuItem.menu ||
                    (menuItem === MenuItem.explore && helper.isAllowedPath('/explore')) ||
                    (menuItem === MenuItem.schedule && helper.isAllowedPath('/journey-planner')) ||
                    (menuItem === MenuItem.ticket && helper.isAllowedPath('/account/tickets')) ||
                    (menuItem === MenuItem.card && helper.isAllowedPath('/account/cards')) ||
                    (menuItem === MenuItem.disturbances && helper.isAllowedPath('/disruption-messages'))
                "
                lines="none">
                <ng-container
                    *ngIf="menuItem === MenuItem.explore && !env.FOOTER?.EXTERNAL_LINKS?.explore"
                    [ngTemplateOutlet]="defaultItem"
                    [ngTemplateOutletContext]="{
                        menuItem: menuItem,
                        tabindex: '-1',
                        routerLink: '/explore' | localize,
                        action: FooterAppMenuAction.CloseMobileMenu,
                        containerClass: 'h-15x min-h-15x w-full',
                        label: 'APP_MENU_EXPLORE' | translate,
                        iconSrc:
                            env.IS_NEW_AFC && router.url?.includes('explore')
                                ? (assetsPath$ | async) + '/img/footer/explore-active.svg'
                                : (assetsPath$ | async) + '/img/footer/explore.svg'
                    }"></ng-container>

                <ng-container
                    *ngIf="menuItem === MenuItem.explore && env.FOOTER?.EXTERNAL_LINKS?.explore"
                    [ngTemplateOutlet]="externalItem"
                    [ngTemplateOutletContext]="{
                        menuItem: menuItem,
                        tabindex: null,
                        action: FooterAppMenuAction.HandleExploreClick,
                        containerClass: 'w-full',
                        label: 'APP_MENU_EXPLORE' | translate,
                        iconSrc: (assetsPath$ | async) + '/img/footer/explore.svg'
                    }"></ng-container>

                <ng-container
                    *ngIf="menuItem === MenuItem.schedule"
                    [ngTemplateOutlet]="defaultItem"
                    [ngTemplateOutletContext]="{
                        menuItem: menuItem,
                        tabindex: '-1',
                        routerLink: '/journey-planner' | localize,
                        action: FooterAppMenuAction.CloseMobileMenu,
                        containerClass: 'w-full',
                        label: 'APP_MENU_SCHEDULE' | translate,
                        iconSrc:
                            env.IS_NEW_AFC && router.url?.includes('journey-planner')
                                ? (assetsPath$ | async) + '/img/footer/journey-planner-active.svg'
                                : (assetsPath$ | async) + '/img/footer/journey-planner.svg'
                    }"></ng-container>

                <ng-container
                    *ngIf="menuItem === MenuItem.ticket"
                    [ngTemplateOutlet]="defaultItem"
                    [ngTemplateOutletContext]="{
                        menuItem: menuItem,
                        tabindex: '-1',
                        routerLink: '/account/tickets' | localize,
                        action: FooterAppMenuAction.CloseMobileMenu,
                        containerClass: 'w-full',
                        label: 'APP_MENU_TICKET' | translate,
                        iconSrc:
                            env.IS_NEW_AFC && router.url?.includes('account/tickets')
                                ? (assetsPath$ | async) + '/img/footer/tickets-active.svg'
                                : (assetsPath$ | async) + '/img/footer/tickets.svg'
                    }"></ng-container>

                <ng-container
                    *ngIf="menuItem === MenuItem.card"
                    [ngTemplateOutlet]="defaultItem"
                    [ngTemplateOutletContext]="{
                        menuItem: menuItem,
                        tabindex: '-1',
                        routerLink: '/account/cards' | localize,
                        action: FooterAppMenuAction.CloseMobileMenu,
                        containerClass: 'w-full',
                        label: 'APP_MENU_CARD' | translate,
                        matIcon: 'footer-cards'
                    }"></ng-container>

                <ng-container
                    *ngIf="menuItem === MenuItem.disturbances"
                    [ngTemplateOutlet]="defaultItem"
                    [ngTemplateOutletContext]="{
                        menuItem: menuItem,
                        tabindex: '-1',
                        routerLink: '/disruption-messages' | localize,
                        action: FooterAppMenuAction.CloseMobileMenu,
                        containerClass: 'w-full',
                        label: 'APP_MENU_DISTURBANCES' | translate,
                        matIcon: 'footer-disruption-messages'
                    }"></ng-container>

                <ng-container *ngIf="menuItem === MenuItem.menu" [ngTemplateOutlet]="mobileMenu"></ng-container>
            </ion-item>
        </ng-container>
    </ion-list>
</ion-toolbar>

<ng-template
    #defaultItem
    let-menuItem="menuItem"
    let-tabindex="tabindex"
    let-routerLink="routerLink"
    let-action="action"
    let-containerClass="containerClass"
    let-label="label"
    let-iconSrc="iconSrc"
    let-matIcon="matIcon">
    <div
        [class]="containerClass"
        [routerLink]="routerLink"
        [attr.tabindex]="tabindex"
        (click)="handleDefaultItemAction(action)"
        role="button">
        <gl-footer-app-link [label]="label">
            <ion-icon *ngIf="iconSrc" [src]="iconSrc" aria-hidden="true" icon></ion-icon>
            <mat-icon *ngIf="matIcon" [svgIcon]="matIcon" icon aria-hidden="true"></mat-icon>
            <span title>
                {{ label }}
            </span>
        </gl-footer-app-link>
    </div>
</ng-template>

<ng-template
    #externalItem
    let-menuItem="menuItem"
    let-tabindex="tabindex"
    let-action="action"
    let-containerClass="containerClass"
    let-label="label"
    let-iconSrc="iconSrc">
    <div [class]="containerClass" [attr.tabindex]="tabindex" (click)="handleDefaultItemAction(action)" role="button">
        <gl-footer-app-link [label]="label">
            <ion-icon *ngIf="iconSrc" [src]="iconSrc" aria-hidden="true" icon></ion-icon>
            <span title>
                {{ label }}
            </span>
        </gl-footer-app-link>
    </div>
</ng-template>

<ng-template #mobileMenu>
    <div
        class="mobile-menu flex w-full flex-col items-center justify-center"
        [routerLink]="env.MOBILE_MENU_CUSTOMIZATION?.IS_PAGE ? ('/mobile-menu' | localize) : []"
        [ngClass]="{
            'vl-app-light:text-white orb-app-light:text-white var-app-light:text-[var(--color-primary)] pn-app-light:text-white sr-app-light:text-white h-11 text-primary dark:text-contrast-yellow':
                isMenuOpen(),
            'vl-app-light:text-white orb-app-light:text-white var-app-light:text-[var(--color-primary)] pn-app-light:text-pink-muted sr-app-light:text-green-fresh text-old_silver dark:text-contrast-yellow dark:opacity-50':
                !isMenuOpen()
        }"
        (click)="toggleMobileMenu()"
        (keydown.enter)="toggleMobileMenu()"
        (keydown.space)="$event.preventDefault(); $event.stopPropagation(); toggleMobileMenu()"
        tabindex="0"
        attr.aria-label="{{
            ((isMenuOpen() ? 'APP_MENU_EXPANDED' : 'APP_MENU_COLLAPSED') | translate) +
                '. ' +
                ('DOUBLE_TAP_TO_ACTIVATE' | translate)
        }}"
        role="button">
        <div class="flex h-6 items-center" aria-hidden="true">
            <button
                class="hamburger hamburger--squeeze flex outline-none"
                [attr.aria-label]="'APP_MENU' | translate"
                [ngClass]="{ 'is-active': isMenuOpen() }"
                tabindex="-1"
                aria-hidden="true">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div>

        <div
            class="menu-text mt-1 text-xs font-bold dark:text-contrast-yellow"
            *ngIf="!isMenuOpen()"
            aria-hidden="true">
            {{ 'APP_MENU' | translate }}
        </div>
    </div>
</ng-template>
